// src/main.ts
import { bootstrapApplication }        from '@angular/platform-browser';
import { importProvidersFrom }         from '@angular/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideHttpClient,withInterceptors, HttpClient } from '@angular/common/http';
import { registerLocaleData }          from '@angular/common';
import localeCs                        from '@angular/common/locales/cs';
import localeDe                        from '@angular/common/locales/de';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader }         from '@ngx-translate/http-loader';
import { AppComponent }                from './app/app.component';
import { appConfig }                   from './app/app.config';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes }                       from './app/app.routes';
import { authInterceptor }             from '../src/app/shared/services/authorization/auth.interceptor';
console.log('[main.ts] Start registerLocaleData');
registerLocaleData(localeCs, 'cs');
registerLocaleData(localeDe, 'de');

export function httpTranslateLoader(http: HttpClient): TranslateHttpLoader {
  console.log('[main.ts] Create TranslateHttpLoader');
  return new TranslateHttpLoader(http, './assets/localization/', '.json');
}
/*
// This is just for onscreen debugging
(() => {
  const oldLog = console.log;
  const el = document.createElement('pre');
  el.style.cssText = 'position:fixed;bottom:0;left:0;width:100%;max-height:30vh;overflow:auto;background:rgba(0,0,0,0.7);color:#0f0;font-size:12px;z-index:9999';
  document.body.appendChild(el);
  console.log = (...args) => {
    oldLog.apply(console, args);
    el.textContent += args.map(a => typeof a==='object'?JSON.stringify(a):a).join(' ') + '\\n';
  };
})();
*/
console.log('[main.ts] Calling bootstrapApplication');
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideHttpClient(
      withInterceptors([ authInterceptor ])
    ),
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'cs',
        loader: {
          provide:    TranslateLoader,
          useFactory: httpTranslateLoader,
          deps:       [HttpClient],
        },
      })
    ),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling:           'enabled'
      })
    )
  ],
})
.then(appRef => {
  console.log('[main.ts] bootstrapApplication succeeded');
  const translate = appRef.injector.get(TranslateService);
  console.log('[main.ts] TranslateService acquired');

  const langs = ['cs','en', 'de'];
  translate.addLangs(langs);
  console.log('[main.ts] Registered langs:', langs);

  translate.setDefaultLang('cs');
  console.log('[main.ts] Set defaultLang to cs');

  const stored = localStorage.getItem('appLang');
  const browser = translate.getBrowserLang();
  console.log('[main.ts] storedLang:', stored, 'browserLang:', browser);

  const initial = (stored && langs.includes(stored))
    ? stored
    : (browser && langs.includes(browser) ? browser : 'cs');
  console.log('[main.ts] Using initial language:', initial);
  translate.use(initial);

  // Expose for MAUI host
  (window as any).setAppLanguage = (lang: string) => {
    console.log('[main.ts] setAppLanguage called with', lang);
    if (langs.includes(lang)) {
      localStorage.setItem('appLang', lang);
      translate.use(lang);
      console.log('[main.ts] Language switched to', lang);
    } else {
      console.warn('[main.ts] Unsupported language:', lang);
    }
  };
})
.catch(err => {
  console.error('[main.ts] bootstrapApplication error:', err);
});
